import React from 'react';
import { Settings, Shield, Bell, Key, Box, Users } from 'lucide-react';

interface Tab {
  id: string;
  label: string;
  icon: React.ElementType;
  description: string;
}

const tabs: Tab[] = [
  {
    id: 'general',
    label: 'General',
    icon: Settings,
    description: 'Basic settings and preferences'
  },
  {
    id: 'security',
    label: 'Security',
    icon: Shield,
    description: 'Security and authentication'
  },
  {
    id: 'notifications',
    label: 'Notifications',
    icon: Bell,
    description: 'Notification preferences'
  },
  {
    id: 'alerts',
    label: 'Alerts',
    icon: Bell,
    description: 'Alert preferences'
  },
  // {
  //   id: 'api',
  //   label: 'API Keys',
  //   icon: Key,
  //   description: 'API access and tokens'
  // },
  {
    id: 'integrations',
    label: 'Integrations',
    icon: Box,
    description: 'Connected services'
  },
  {
    id: 'team',
    label: 'Team',
    icon: Users,
    description: 'Team members and roles'
  }
];

interface SettingsTabsProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

export const SettingsTabs: React.FC<SettingsTabsProps> = ({
  activeTab,
  onTabChange
}) => {
  return (
    <div className="bg-[#0F1629] rounded-xl border border-gray-800/50">
      <nav className="space-y-1 p-4" aria-label="Settings tabs">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`w-full flex items-start space-x-3 p-3 rounded-lg transition-colors ${
                isActive
                  ? 'bg-gray-800/50 text-white'
                  : 'text-gray-400 hover:bg-gray-800/30 hover:text-gray-300'
              }`}
            >
              <Icon className="h-5 w-5 mt-0.5" />
              <div className="flex-1 text-left">
                <div className="text-sm font-medium">{tab.label}</div>
                <div className="text-xs text-gray-500">{tab.description}</div>
              </div>
            </button>
          );
        })}
      </nav>
    </div>
  );
};